export default __webpack_public_path__ + "resources/icons/n410-93a1.webp";